import { parseCurrencyString } from "@/utils/parseCurrencyString";
import * as yup from "yup";

export const bonusSchema = yup.object({
  description: yup.string().when("$isWriteOff", {
    is: false,
    then: (schema) => schema.required("Descrição é obrigatória"),
    otherwise: (schema) => schema.notRequired(),
  }),
  employee_id: yup.string().required("Funcionário é obrigatório"),
  amount: yup
    .string()
    .transform(parseCurrencyString)
    .test(
      "is-required",
      "Valor é obrigatório",
      (value) => !!value && value !== "0" && value !== "0.00",
    )
    .test("is-valid", "Valor deve ser maior que zero", (value) => {
      const numberValue = parseFloat(value ?? "0");
      return !isNaN(numberValue) && numberValue > 0;
    }),
  expiry_date: yup
    .string()
    .transform((value) => (value ? value.trim() : null))
    .when("$isWriteOff", {
      is: false,
      then: (schema) =>
        schema
          .required("Data de vencimento obrigatória")
          .matches(/^\d{4}-\d{2}-\d{2}$/, "Formato inválido (YYYY-MM-DD)"),

      otherwise: (schema) => schema.notRequired(),
    }),
});
